import * as types from './types';

export function updatePatientFirstname(payload) {
  return {
    type: types.UPDATE_PATIENT_FIRSTNAME,
    payload
  };
}

export function updatePatientLastname(payload) {
  return {
    type: types.UPDATE_PATIENT_LASTNAME,
    payload
  };
}

export function updatePatientDob(payload) {
  return {
    type: types.UPDATE_PATIENT_DOB,
    payload
  };
}

export function updatePatientDueDate(payload) {
  return {
    type: types.UPDATE_PATIENT_DUE_DATE,
    payload
  };
}

export function updatePatientGender(payload) {
  return {
    type: types.UPDATE_PATIENT_GENDER,
    payload
  };
}

export function updatePatientStory(payload) {
  return {
    type: types.UPDATE_PATIENT_GENDER,
    payload
  };
}

export function updatePatientCountry(payload) {
  return {
    type: types.UPDATE_PATIENT_COUNTRY,
    payload
  };
}

export function updatePatientSecondaryCountry(payload) {
  return {
    type: types.UPDATE_PATIENT_SECONDARY_COUNTRY,
    payload
  };
}

export function updatePatientPhonetype(payload) {
  return {
    type: types.UPDATE_PATIENT_PHONETYPE,
    payload
  };
}

export function updatePatientPhonetype2(payload) {
  return {
    type: types.UPDATE_PATIENT_PHONETYPE_2,
    payload
  };
}

export function updatePatientPhonetype3(payload) {
  return {
    type: types.UPDATE_PATIENT_PHONETYPE_3,
    payload
  };
}

export function updatePatientPhonetype4(payload) {
  return {
    type: types.UPDATE_PATIENT_PHONETYPE_4,
    payload
  };
}

export function updatePatientLanguages(payload) {
  return {
    type: types.UPDATE_PATIENT_LANGUAGES,
    payload
  };
}

export function updatePatientNeedInterpreter(payload) {
  return {
    type: types.UPDATE_PATIENT_NEEDINTERPRETER,
    payload
  };
}

export function updatePatientPCPLetter(payload) {
  return {
    type: types.UPDATE_PATIENT_PCPLETTER,
    payload
  };
}

export function updatePatientCardiologistLetter(payload) {
  return {
    type: types.UPDATE_PATIENT_CARDIOLOGISTLETTER,
    payload
  };
}

export function persistPatientInfo(firstName, lastName, dob, gender, dueDate, story) {
  return {
    type: types.PERSIST_PATIENT_INFO,
    firstName,
    lastName,
    dob,
    gender,
    dueDate,
    story
  };
}

export function persistPatientContactInfo(
  addressline1,
  addressline2,
  city,
  state,
  country,
  zip,
  secondaryAddressline1,
  secondaryAddressline2,
  secondaryCity,
  secondaryState,
  secondaryCountry,
  secondaryZip,
  email,
  email2,
  phone,
  phone2,
  phone3,
  phone4,
  phonetype,
  phonetype2,
  phonetype3,
  phonetype4,
  languages,
  needInterpreter
) {
  return {
    type: types.PERSIST_PATIENT_CONTACT_INFO,
    addressline1,
    addressline2,
    city,
    state,
    country,
    zip,
    secondaryAddressline1,
    secondaryAddressline2,
    secondaryCity,
    secondaryState,
    secondaryCountry,
    secondaryZip,
    email,
    email2,
    phone,
    phone2,
    phone3,
    phone4,
    phonetype,
    phonetype2,
    phonetype3,
    phonetype4,
    languages,
    needInterpreter
  };
}

export function persistPatientMDInfo(
  pcp,
  pcpphone,
  pcpemail,
  cardiologist,
  cardiologistphone,
  cardiologistemail,
  obgyn,
  obgynphone,
  obgynemail,
  pcpletter,
  cardiologistletter,
  obgynletter
) {
  return {
    type: types.PERSIST_PATIENT_MD_INFO,
    pcp,
    pcpphone,
    pcpemail,
    cardiologist,
    cardiologistphone,
    cardiologistemail,
    obgyn,
    obgynphone,
    obgynemail,
    pcpletter,
    cardiologistletter,
    obgynletter
  };
}

export function persistPatientBCHInfo(
  program,
  preferredSurgeon,
  preferredSurgeonName,
  preferredCardiologist,
  preferredCardiologistName,
  inpatient,
  whyChoose,
  hospitalName
) {
  return {
    type: types.PERSIST_PATIENT_BCH_INFO,
    program,
    preferredSurgeon,
    preferredSurgeonName,
    preferredCardiologist,
    preferredCardiologistName,
    inpatient,
    whyChoose,
    hospitalName
  };
}
